import "./index.scss";
import { NavLink } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";

export const ShippingPolicy = () => (
  <div className="shipping-policy"> 
    <ReactHelmetWithProvider>
      <meta
        name="description"
        content="Learn about GCX’s delivery methods. Discover how and when your gift cards will be securely delivered and available on time every time."
      />
      <title>Secure Gift Card Delivery & Trusted Methods | GCX</title>
      <link
        rel="canonical"
        href={process.env.REACT_APP_URL + INTERNAL_PATHS.SHIPPING_POLICY}
      />
    </ReactHelmetWithProvider>
    <ReactHelmetWithProvider>
      <title>Secure Gift Card Delivery & Trusted Methods | GCX</title>
      <link
        rel="canonical"
        href={process.env.REACT_APP_URL + INTERNAL_PATHS.SHIPPING_POLICY}
      />
    </ReactHelmetWithProvider>
    <h1>Getting Your Gift Cards with GCX</h1>
    <h3>For Buyers</h3>
    <ul>
      <li>
        <strong>eGift Cards &amp; Vouchers: </strong>
        Most electronic gift cards are delivered instantly to your{" "}
        <NavLink to={INTERNAL_PATHS.MY_ORDERS}>GCX account</NavLink>, however
        processing may take up to 24 hours for additional verification.
        <br />
        <em>
          *Buyers are responsible for entering their correct billing and
          shipping address and will be held liable for any misrepresentation of
          shipment information and related fees.
        </em>
      </li>
    </ul>
    <h3>For Sellers</h3>
    <p></p>
    <ul>
      <li>
        <strong>eGift Cards &amp; Vouchers: </strong>
        Shipping is free and automatic—let’s raise a glass to that! As soon as
        the sale has been confirmed, it will automatically transfer from your
        listings to the buyer's GCX account.
        <br />
        <em>
          *Should you misplace, use, or sell your gift card while it is listed
          on GCX, you must immediately remove the item, or you will be held
          liable for the full value and any associated fees. Please view our{" "}
          <NavLink to={INTERNAL_PATHS.TERMS_OF_USE}>terms of use</NavLink> for
          more information.
        </em>
      </li>
    </ul>
  </div>
);
